// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"81":"8ca39b21","122":"be8a26f3","123":"6dd2b1c8","261":"c01a6ee4","427":"f3b3ce6f","462":"298fc63e","624":"64170070","791":"711eef92","831":"434c451a","958":"2c662e32"}[chunkId] + ".chunk.js";
};